'use client'
import React, { useState } from 'react'
import { Button } from '@/shared/ui/button'
import { ChevronDown, ChevronUp } from 'lucide-react'
import { cn } from '@/shared/lib/classnames'

export interface ShowMoreTextProps {
  text: string
  maxLength?: number
  className?: string
  textClassName?: string
  buttonClassName?: string
  showMoreText?: string
  showLessText?: string
  endText?: string
}

export default function ShowMoreText({
  text,
  maxLength = 150,
  className,
  textClassName,
  buttonClassName,
  showMoreText = 'Читать полностью',
  showLessText = 'Свернуть',
  endText = '...',
}: ShowMoreTextProps) {
  const [isExpanded, setIsExpanded] = useState(false)

  if (!text || text.length <= maxLength) {
    return <span className={cn('block', textClassName)}>{text}</span>
  }

  const truncatedText = text.slice(0, maxLength) + endText

  return (
    <div className={cn('flex flex-col gap-2', className)}>
      <span className={cn('block', textClassName)}>{isExpanded ? text : truncatedText}</span>

      <Button
        variant="ghost"
        size="sm"
        className={cn(
          'self-start p-0 h-auto text-xs text-muted-foreground hover:text-foreground flex items-center gap-1',
          buttonClassName,
        )}
        onClick={(e) => {
          e.stopPropagation()
          setIsExpanded(!isExpanded)
        }}
      >
        {isExpanded ? <>{showLessText}</> : <>{showMoreText}</>}
      </Button>
    </div>
  )
}
